import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'intializeEditorViewOutsideOrgState',
    function intializeEditorViewOutsideOrgState() {
        let editorViewState = getStore().currentState.editorViewStateOutsideOrg;
        let initialEditorViewState = getStore().initialState.editorViewStateOutsideOrg;
        editorViewState.content = initialEditorViewState.content;
    }
);
